import { NylasDisconnectConnectionRequestContent, NylasDisconnectConnectionResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to disconnect a specific Nylas connection
 * @param request Connection disconnection parameters
 * @returns Promise with success status
 */
export const disconnectIntegrationConnectionApi = async (request: NylasDisconnectConnectionRequestContent): Promise<NylasDisconnectConnectionResponseContent> => {
  const apiRequest = createApiRequest<NylasDisconnectConnectionResponseContent>('post', '/integrations/nylas/connections/disconnect');
  return apiRequest(request);
};
